const { connect } = require('react-redux')
const Helpers = require('../../../_plugins/lib/helpers')

const mapStateToProps = state => {
  return {
    splitTestData: state.splitTestData
  }
}

const mapDispatchToProps = (dispatch, ownProps = { }) => {
  const splitTestIsActive = (splitTest, splitTests) => {
    if (!splitTest) return false
    if (splitTest.match(/_/)) splitTest = snakeToCamel(splitTest)
    splitTest = splitTests[splitTest] || { }
    return splitTest.active || false
  }

  // Takes a string of the split test name (can be the snake case version or the camel case version), also takes the object you wish to inject into the state for the defined split test
  const injectSplitTestData = (splitTest, newSplitTestData) => {
    if (!splitTest || typeof newSplitTestData !== 'object') return false // Value could be set to false, so check if its not defined this way instead.
    if (splitTest.match(/_/)) splitTest = snakeToCamel(splitTest)
    dispatch({
      type: 'INJECT_TEST_DATA',
      data: { name: splitTest, newSplitTestData }
    })
  }

  const snakeToCamel = string => {
    return string.replace(/(_\w)/g, (match) => match[1].toUpperCase())
  }

  const detectIE = () => {
    var versionArr = navigator.userAgent.match(/MSIE (\d+\.\d+);/)
    if (versionArr instanceof Array && versionArr.length > 1) return versionArr[1] / 1
    return false
  }

  // Pass a 'pattern' in as a regular expression to only active this split test on certain pages, disclude it and will always run
  const initialiseSplitTest = splitTestData => {
    if (!splitTestData || !splitTestData.name || !splitTestData.percentage) return false
    const { pageData = { } } = ownProps
    if (splitTestData.pattern && !pageData.pageName.match(splitTestData.pattern)) return false
    let stopTheSplitTest = false
    if (splitTestData.discludeIE) {
      splitTestData.discludeIE.map((version) => {
        if (detectIE() === version) stopTheSplitTest = true
      })
    }
    if (stopTheSplitTest) return false
    const status = Helpers.isSplitTest(splitTestData.name, splitTestData.percentage)
    dispatch({
      type: 'INITIALISE_TEST',
      data: { name: snakeToCamel(splitTestData.name), status }
    })
    return status
  }
  return {
    splitTestIsActive,
    injectSplitTestData,
    initialiseSplitTest
  }
}

const connectedComponent = (WrappedComponent) => connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedComponent)

module.exports = connectedComponent



// WEBPACK FOOTER //
// ./shared/stores/connects/splitTests.jsx